import { Editor } from '@monaco-editor/react';
import { Box } from '@mui/material';
import {
  InputContainer,
  PullRequestInput,
  ReloadButton,
  RulesSelectionsContainer,
  RunButton
} from '../../Playground.style';
import usePlaygroundInputs from './usePlaygroundInputs';
import { useGetDashboardData } from '../../../dashboard/hooks/useGetDashboardData';
import { Loader } from '@linearb/linui-common';
import { SelectRulesFile } from '../SelectRulesFile';

export const InputSection = ({
  reset,
  execute,
  ruleFileValidator,
  loading,
  context
}) => {
  const { prUrl, setPRUrl, validationError, initialized } =
    usePlaygroundInputs();
  const inputError = !!validationError && initialized;
  const disableLoadPRButton =
    loading || !initialized || !context || !Object.keys(context || {}).length;
  const { isLoading: isLoadingOrganization } = useGetDashboardData();

  return (
    <InputContainer>
      <RulesSelectionsContainer>
        <Box mb={1}>
          <PullRequestInput
            error={inputError}
            label='Pull Request link'
            value={prUrl}
            helperText={inputError ? validationError : null}
            onChange={e => setPRUrl(e.target.value || '')}
            disabled={isLoadingOrganization}
          />
        </Box>

        <Box mb={1}>
          <SelectRulesFile setRuleFile={ruleFileValidator.setRuleFile} />
        </Box>

        <Box mb={1}>
          <RunButton
            fullWidth
            variant='contained'
            disabled={
              ruleFileValidator.errors || inputError || loading || !initialized
            }
            onClick={() => execute(prUrl)}
          >
            Run gitStream
          </RunButton>
        </Box>

        <Box mb={1}>
          <ReloadButton
            fullWidth
            onClick={reset}
            disabled={disableLoadPRButton}
          >
            Clear PR cache
          </ReloadButton>
        </Box>
      </RulesSelectionsContainer>

      <Editor
        language='yaml'
        value={ruleFileValidator.ruleFile}
        onChange={text => ruleFileValidator.setRuleFile(text)}
        theme='vs-dark'
        loading={<Loader />}
        options={{
          readOnly: isLoadingOrganization,
          domReadOnly: isLoadingOrganization
        }}
      />
    </InputContainer>
  );
};

export default InputSection;
